import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSelector.scss';

const LanguageSelector = () => {
  const { i18n, t } = useTranslation('common');

  const languages = [
    {
      code: 'hu',
      name: 'Magyar',
      flag: 'https://flagcdn.com/hu.svg'
    },
    {
      code: 'en',
      name: 'English',
      flag: 'https://flagcdn.com/gb.svg'
    },
    {
      code: 'de',
      name: 'Deutsch',
      flag: 'https://flagcdn.com/de.svg'
    },
    {
      code: 'cz',
      name: 'Čeština',
      flag: 'https://flagcdn.com/cz.svg'
    },
    {
      code: 'cn',
      name: '中文',
      flag: 'https://flagcdn.com/cn.svg'
    }
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-selector">
      <h3>{t('footer.languageSelector', 'Language')}</h3>
      <div className="language-flags">
        {languages.map((lang) => (
          <div 
            key={lang.code} 
            className={`language-option ${i18n.language === lang.code ? 'active' : ''}`}
            onClick={() => changeLanguage(lang.code)}
          >
            <img 
              src={lang.flag} 
              alt={`${lang.name} flag`} 
              className="language-flag"
            />
            <span className="language-name">{t(`footer.languageName`, { lng: lang.code })}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LanguageSelector;